<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
    [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg">

    <ng-container *ngIf="consulta">
        <ng-container *ngFor="let r of consulta?.registros; let i = index">
            <h2 class="subtitle subtitle-danger"> DÍVIDA VENCIDA {{i+1}}</h2>
            <ul class="card-list-striped py-1">
                <li>
                    <span class="text-secondary">DATA OCORRÊNCIA:</span>
                    <span class="text-justify">{{ r?.data_ocorrencia || msgNull }}</span>
                </li>
                <li>
                    <span class="text-secondary">VALOR:</span>
                    <span class="text-justify">{{ r?.valor || msgNull }}</span>
                </li>
                <li>
                    <span class="text-secondary">ORIGEM:</span>
                    <span class="text-justify">{{ r?.origem || msgNull }}</span>
                </li>
                <li>
                    <span class="text-secondary">CONTRATO:</span>
                    <span class="text-justify">{{ r?.contrato || msgNull }}</span>
                </li>
                <li>
                    <span class="text-secondary">AVALISTA:</span>
                    <span class="text-justify">{{ r?.avalista || msgNull }}</span>
                </li>
                <li>
                    <span class="text-secondary">MODALIDADE:</span>
                    <span class="text-justify">{{ r?.modalidade || msgNull }}</span>
                </li>
            </ul>
        </ng-container>
    </ng-container>

</app-card-consulta>